export default [
    {
        path: '/my-account',
        name: 'My Account',
        component: () => import('@/views/my-account'),
        meta:
        {
            page: 'my-account',
        },
        children:
        [
            {
                path: 'notifications',
                name: 'Notifications',
                component: () => import('@/views/my-account'),
                meta:
                {
                    page: 'notifications',
                },
            },
            {
                path: 'chats',
                name: 'My Account Chat Rooms',
                component: () => import('@/views/my-account'),
                meta:
                {
                    page: 'chats',
                    subPage: 'list',
                },
                children:
                [
                    {
                        path: 'new',
                        name: 'New Messages',
                        component: () => import('@/views/my-account'),
                        meta:
                        {
                            page: 'chats',
                            subPage: 'create',
                        },
                    },
                    {
                        path: ':code',
                        name: 'View Messages',
                        component: () => import('@/views/my-account'),
                        meta:
                        {
                            page: 'chats',
                            subPage: 'view',
                        },
                    },
                ],
            },
        ],
    },


];



// WEBPACK FOOTER //
// ./src/views/my-account/route.js